module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-hello.f64c22a0.png";